import { NgModule } from '@angular/core';
import { MatAutocompleteModule, MatProgressSpinnerModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { HorizontalBarChartModule } from '@core/components/charts/horizontal-bar/horizontal-bar.module';
import { PieChartModule } from '@core/components/charts/pie/pie.module';
import { VerticalBarChartModule } from '@core/components/charts/vertical-bar/vertical-bar.module';
import { DataCardModule } from '@core/components/data-card/data-card.module';
import { FcDataCardModule } from '@core/components/fc-data-card/fc-data-card.module';
import { FcDateInputModule } from '@core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcCompaniesInputModule } from '@core/components/fc-input/search-many/fc-companies-input/fc-companies-input.module';
import { FcLocationGroupsInputModule } from '@core/components/fc-input/search-many/fc-location-groups-input/fc-location-groups-input.module';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcSegmentsInputModule } from '@core/components/fc-input/search-many/fc-segments-input/fc-segments-input.module';
import { CompaniesComponentModule } from '@core/components/inputs/companies/companies.module';
import { LocationsGroupsComponentModule } from '@core/components/inputs/locations-groups/locations-groups.module';
import { LocationsComponentModule } from '@core/components/inputs/locations/locations.module';
import { MaintenanceTypeModule } from '@core/components/inputs/maintenance-type/maintenance-type.module';
import { SegmentsModule } from '@core/components/inputs/segments/segments.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ChartDateIntervalSelectorModule } from '../../../core/components/charts/chart-date-interval-selector/chart-date-interval-selector.module';
import { LineChartModule } from '../../../core/components/charts/line/line.module';
import { FcDataCardV2Component } from '../../../core/components/fc-data-card-v2/fc-data-card-v2.component';
import { FcDataCardV2Module } from '../../../core/components/fc-data-card-v2/fc-data-card-v2.module';
import { FcStoragesInputModule } from '../../../core/components/fc-input/search-many/fc-storages-input/fc-storages-input.module';
import { FcLocationInputModule } from '../../../core/components/fc-input/search-one/fc-location-input/fc-location-input.module';
import { FcProductInputModule } from '../../../core/components/fc-input/search-one/fc-product-input/fc-product-input.module';
import { FilterModule } from '../components/filter/filters.module';
import { ReportFilterApi } from '../components/filter/services/report-filter-api.service';
import { StorageMovementCardComponent } from './components/storage-movement-card/storage-movement-card.component';
import { DashboardStorageMovementsService } from './services/dashboard-storage-movements.service';
import { DashboardStorageMovementsComponent } from './storage-movements.component';

const routes: Routes = [
  {
    path: 'relatorios/movimentacoes',
    component: DashboardStorageMovementsComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.REPORTS.STORAGE_MOVEMENTS' }
  }
];

@NgModule({
  declarations: [
    DashboardStorageMovementsComponent,
    StorageMovementCardComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatTooltipModule,
    MatSelectModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    DataCardModule,
    FcDataCardModule,
    PieChartModule,
    HorizontalBarChartModule,
    VerticalBarChartModule,
    LocationsComponentModule,
    MaintenanceTypeModule,
    CompaniesComponentModule,
    LocationsGroupsComponentModule,
    SegmentsModule,
    FilterModule,
    FcLocationsInputModule,
    FcMaintenanceTypesInputModule,
    FcSegmentsInputModule,
    FcLocationGroupsInputModule,
    FcCompaniesInputModule,
    FcDateInputModule,
    FcLocationInputModule,
    FcProductInputModule,
    FcStoragesInputModule,
    ChartDateIntervalSelectorModule,
    LineChartModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatButtonModule,
    FcDataCardV2Module
  ],
  exports: [
    DashboardStorageMovementsComponent
  ],
  providers: [
    DashboardStorageMovementsService,
    ReportFilterApi
  ]
})

export class DashboardStorageMovementsModule {}
